export const shopTheLookTrackingCategory = 'wear it with'
export const viewProductAction = 'view product'
